import * as yup from 'yup';
import { isFieldVisible } from '../../helpers';
import { buildDefaults } from '../shared/campaignDefaults';
import {
  hasBaseErrors,
  hasCaptureErrors,
  hasInvalidScheduledDelay,
  hasMissingGroups,
  hasMissingRequiredKeywords,
} from '../shared/primaryActionChecks';
import { commonSchemaShape, withMessageOrderTest } from '../shared/validationSchema';
import { withoutMessageTime } from '../shared/payloadMessages';
import { CampaignTypeSpec } from '../policy';
import { policyIssue } from '../issues';
import { inboundRecipients, standardFields } from './shared';

export const joinSpec: CampaignTypeSpec = {
  externalType: 'text_to_join',
  externalTypeFor: config => (isFieldVisible(config.keywords) ? 'text_to_join' : 'contact_to_group'),
  scheduleKind: 'join',
  // Contacts land in "All Contacts" without triggering anything, so a contact-to-group
  // campaign targeting only that group would never start. Text-to-join is unaffected.
  recipients: config => ({
    ...inboundRecipients(config),
    ...(isFieldVisible(config.keywords) ? {} : { groupTypes: 'custom' }),
  }),
  fields: standardFields,
  defaults: config => buildDefaults(config, { scheduledType: 'immediate' }),

  issues: (values, config) => policyIssue(
    hasBaseErrors(values, config)
    || hasCaptureErrors(values)
    || hasInvalidScheduledDelay(values)
    || (isFieldVisible(config.recipients) && hasMissingGroups(values))
    || hasMissingRequiredKeywords(values, config),
    'join-primary-blocked',
  ),

  payload: ({ base, values, config }) => ({
    ...base,
    groups: values.groupIds ?? [],
    keywords: isFieldVisible(config.keywords) ? values.keywordIds : undefined,
    scheduledMessages: withoutMessageTime(base.scheduledMessages),
  }),

  schema: config => withMessageOrderTest(
    yup.object(commonSchemaShape(config, { messages: true, groups: true, keywords: true })),
  ),
};
